import { checkAge } from '~/helpers/date'
import { Partner } from '~/data/common'
import { HomeEquityColdRequest } from '~/data/loans/home-equity/cold-offer'

const flowcrediFilters = (lastRequest: HomeEquityColdRequest): boolean => {
  return (
    lastRequest?.monthly_income >= 2500 &&
    lastRequest?.collateral_value >= 200000 &&
    lastRequest?.requested_loan_amount >= 30000 &&
    lastRequest?.is_rural === false
  )
}

const conexaoFinanceiraFilters = (
  lastRequest: HomeEquityColdRequest,
  extraQuestions,
  score: number,
): boolean => {
  const disabled = true
  if (disabled) return false

  return (
    checkAge(22, 60, lastRequest?.birth_date) &&
    score >= 400 &&
    lastRequest?.monthly_income >= 3000 &&
    lastRequest?.collateral_value >= 250000 &&
    lastRequest?.requested_loan_amount >= 50000 &&
    lastRequest?.is_rural === false &&
    extraQuestions?.annotated === false
  )
}

export const getHomeEquityAffiliates = (
  lastRequest: HomeEquityColdRequest,
  extraQuestions,
  score: number,
): Record<Partner | string, boolean> => {
  return {
    [Partner.FLOWCREDI]: flowcrediFilters(lastRequest),
    [Partner.CONEXAO_FINANCEIRA]: conexaoFinanceiraFilters(
      lastRequest,
      extraQuestions,
      score,
    ),
  }
}
